import { useState } from 'react';
import { Else, If, Then } from 'react-if';
import { useModal } from '@ebay/nice-modal-react';
import { useIsMounted } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useIsomorphicViewportDevice } from '@zep/react';
import { UploadTypeSelectionModal } from '../../components';
import ShowDesktop from '../../components/common/ShowDesktop';
import Empty from '../../components/service/common/Empty';
import ManageAssetList from '../../components/service/manages/ManageAssetList';
import { useMyAssets } from '../../services';
import S from './AssetControl.module.scss';
export const ManageAssetsPageView = () => {
  const uploadModal = useModal(UploadTypeSelectionModal);
  const {
    t
  } = useTranslation(['store', 'manage']);
  const {
    isMobile
  } = useIsomorphicViewportDevice();
  const [page, setPage] = useState(1);
  const {
    data
  } = useMyAssets(page);
  const isMounted = useIsMounted();
  const handleUploadAssetModalShow = () => {
    logger.track('store_upload_btn');
    uploadModal.show();
  };
  return <If condition={!isMounted || isMobile} data-sentry-element="If" data-sentry-component="ManageAssetsPageView" data-sentry-source-file="manageAssets.tsx">
      <Then data-sentry-element="Then" data-sentry-source-file="manageAssets.tsx">
        <ShowDesktop data-sentry-element="ShowDesktop" data-sentry-source-file="manageAssets.tsx" />
      </Then>
      <Else data-sentry-element="Else" data-sentry-source-file="manageAssets.tsx">
        <div className={S.page_title}>{t('manage:manage_my_assets')}</div>
        <If condition={data.items?.length > 0} data-sentry-element="If" data-sentry-source-file="manageAssets.tsx">
          <Then data-sentry-element="Then" data-sentry-source-file="manageAssets.tsx">
            <ManageAssetList assets={data.items} lastPageNo={data.pager?.totalPages} nowPageNo={data.pager?.currentPage} handlePageChange={setPage} data-sentry-element="ManageAssetList" data-sentry-source-file="manageAssets.tsx" />
          </Then>
          <Else data-sentry-element="Else" data-sentry-source-file="manageAssets.tsx">
            <Empty image={{
            url: '/images/light/assetStore/empty_box.png',
            width: 125,
            height: 125
          }} emptyItem={t('manage:myAsset.empty.titleItem')} description={t('manage:myAsset.empty.description')} ctaText={t('store:store_asset_upload')} onClickCTA={() => handleUploadAssetModalShow()} data-sentry-element="Empty" data-sentry-source-file="manageAssets.tsx" />
          </Else>
        </If>
      </Else>
    </If>;
};